/**
 * PlanExecutionList — lista visual das 7 etapas do worker pipeline.
 *
 * Estatica (descritiva). Numeracao em monospace verde, descricao em
 * texto regular. Mostrado no Step4Review pra usuario revisar antes de
 * disparar o worker.
 */
import { Stack, Text } from '@mantine/core'

const STEPS: { n: number; description: string }[] = [
  { n: 1, description: 'ACM RequestCertificate (DevOps account) — SAN wildcard da zona do tenant' },
  { n: 2, description: 'Route53 CNAMEs validation (cross-account na conta tenant)' },
  { n: 3, description: 'Aguardar cert ISSUED (timeout 5min)' },
  { n: 4, description: 'Wildcard A record na zona do tenant -> ALB DevOpsSys' },
  { n: 5, description: 'ALB listener rule (Host=hostname público -> broker target group)' },
  { n: 6, description: 'INSERT applications no DB + invalidate broker cache' },
  { n: 7, description: 'Smoke test (30s x 5min, aceita HTTP 200/302/401/403)' },
]

export function PlanExecutionList() {
  return (
    <Stack gap={4}>
      {STEPS.map((s) => (
        <div
          key={s.n}
          style={{
            padding: '10px 12px',
            borderLeft: '2px solid var(--mantine-color-gray-3)',
            background: 'var(--ai-bg-elevated)',
            borderRadius: '0 6px 6px 0',
            fontSize: '0.86rem',
          }}
        >
          <Text
            component="span"
            ff="JetBrains Mono, monospace"
            fw={700}
            c="var(--ai-brand-verde, #00a86b)"
            mr={8}
          >
            [{s.n}]
          </Text>
          <Text component="span" size="sm">{s.description}</Text>
        </div>
      ))}
    </Stack>
  )
}
